/**
 * Joy may inject widgets near .btnbox-product. Keep ebook under the ATC button.
 * Only moves product-page promo — never cart drawer / side-cart HTML.
 */
(function () {
  function productEbookWrap() {
    return (
      document.querySelector('.gu-free-ebook-wrap--below-atc') ||
      document.querySelector('.gu-free-ebook-wrap--above-atc')
    );
  }

  function placeEbookPromo() {
    var ebook = productEbookWrap();
    if (!ebook || ebook.classList.contains('gu-free-ebook-wrap--side-cart')) return;

    var delivery = document.querySelector('.product-deliverdate.deliverydatebox');
    if (delivery && delivery.parentNode && ebook !== delivery.previousElementSibling) {
      delivery.parentNode.insertBefore(ebook, delivery);
      return;
    }

    var btnBox = document.querySelector('.btnbox-product');
    if (btnBox && btnBox.parentNode && ebook !== btnBox.nextElementSibling) {
      btnBox.parentNode.insertBefore(ebook, btnBox.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeEbookPromo);
  } else {
    placeEbookPromo();
  }

  var root =
    document.querySelector('.productView') ||
    document.querySelector('.product__info-container') ||
    document.querySelector('.productView-product');

  if (!root) return;

  var timer;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(placeEbookPromo, 100);
  });
  observer.observe(root, { childList: true, subtree: true });
})();
